@if ({
  report: report$ | async,
  }; as content) {
  <p class="m-t-20">{{ 'reports.purchaseSummary.info' | cxTranslate }}</p>
  <p class="m-t-8">{{ 'reports.purchaseSummary.example' | cxTranslate }}</p>
  <p class="m-0">{{ 'reports.purchaseSummary.note' | cxTranslate }}</p>
  <p class="section-title m-t-20 m-b-0">{{ 'reports.purchaseSummary.annualPurchases' | cxTranslate }}</p>
  @if (!content.report?.isLoading) {
    @if (!content.report?.hasError) {
      <div class="m-t-12">
        @if (content.report?.report?.header?.length) {
          <div class="grid-items">
            @for (item of content.report?.report?.header; track item) {
              <div class="grid-item">
                <div class="grid-item__title">{{ item.label }}</div>
                <div class="grid-item__value">
                  @if (item.value?.value !== 0) {
                    <button type="button" class="btn-annual-purchase btn-action" (click)="openAnualPurchaseModal(item)">
                      {{ item.value?.formattedValue }}
                    </button>
                  } @else {
                    {{ item.value?.formattedValue }}
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="ff-bold text-center">{{ 'reports.purchaseSummary.noContent' | cxTranslate }}</p>
        }
      </div>
      <div class="m-t-20">
        @if (content.report?.report?.body?.length) {
          <table class="table-responsive table-md">
            <thead>
              <tr>
                <th>{{ 'reports.purchaseSummary.periodName' | cxTranslate }}</th>
                <th>{{ 'reports.purchaseSummary.purchaseDollars' | cxTranslate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (item of content.report?.report?.body; track item) {
                <tr>
                  <td>
                    <span class="responsive-title m-r-4">{{ 'reports.purchaseSummary.periodName' | cxTranslate }}: </span>
                    {{ item.label }}
                  </td>
                  <td class="grid-item__value" [ngClass]="{ 'not-zero': item?.value?.value }">
                    <span class="responsive-title m-r-4">{{ 'reports.purchaseSummary.purchaseDollars' | cxTranslate }}: </span>
                    @if (item.value?.value !== 0) {
                      <button type="button" class="btn-annual-purchase btn-action" (click)="openAnualPurchaseModal(item)">
                        {{ item.value?.formattedValue }}
                      </button>
                    } @else {
                      {{ item.value?.formattedValue }}
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p class="ff-bold text-center">{{ 'reports.purchaseSummary.noContent' | cxTranslate }}</p>
        }
      </div>
    } @else {
      <alert [alert]="alertDanger"></alert>
    }
  } @else {
    <div class="m-t-20">
      <local-loader></local-loader>
    </div>
  }
}